import { render, staticRenderFns } from "./HostingKvmGraphs.vue?vue&type=template&id=860e2bd4&scoped=true&"
import script from "./HostingKvmGraphs.vue?vue&type=script&lang=js&"
export * from "./HostingKvmGraphs.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmGraphs.vue?vue&type=style&index=0&id=860e2bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860e2bd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('860e2bd4')) {
      api.createRecord('860e2bd4', component.options)
    } else {
      api.reload('860e2bd4', component.options)
    }
    module.hot.accept("./HostingKvmGraphs.vue?vue&type=template&id=860e2bd4&scoped=true&", function () {
      api.rerender('860e2bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmGraphs.vue"
export default component.exports